package com.eladfinish.bible.contest.screens.lexicographicalSort.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.OutputChapters
import com.eladfinish.bible.contest.ui.icons.AppIcons
import dev.icerock.moko.resources.compose.localized
import dev.icerock.moko.resources.desc.desc

/**
 * Inline (non-bottom-sheet) picker for the [OutputChapters] scope of the lexicographical
 * sort - i.e. whether to sort a single chapter, all chapters covered by the current
 * "mikud", or the entire book.
 */
@Composable
fun LexicographicalSortOutputPicker(
    selected: OutputChapters,
    onSelect: (OutputChapters) -> Unit,
    modifier: Modifier = Modifier,
) {
    Column(modifier = modifier.fillMaxWidth()) {
        OutputChapters.entries.forEach { outputChapters ->
            val isSelected = outputChapters == selected

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(8.dp))
                    .background(
                        if (isSelected) {
                            MaterialTheme.colorScheme.primaryContainer
                        } else {
                            MaterialTheme.colorScheme.surface
                        }
                    )
                    .clickable { onSelect(outputChapters) }
                    .padding(horizontal = 12.dp, vertical = 12.dp),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Icon(
                    imageVector = if (isSelected) {
                        AppIcons.RadioButtonChecked
                    } else {
                        AppIcons.RadioButtonUnchecked
                    },
                    contentDescription = null,
                    tint = MaterialTheme.colorScheme.primary,
                )

                Spacer(modifier = Modifier.width(12.dp))

                Text(
                    text = outputChapters.place.desc().localized(),
                    modifier = Modifier.weight(1f),
                )

                if (outputChapters.isPremium) {
                    Icon(
                        imageVector = AppIcons.WorkspacePremium,
                        contentDescription = null,
                        tint = MaterialTheme.colorScheme.primary,
                    )
                }
            }

            Spacer(modifier = Modifier.height(8.dp))
        }
    }
}
